import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const ClientCarousel = ({ extraClassName = "" }) => {
    const owlOptions = {
        items: 5,
        margin: 65,
        smartSpeed: 700,
        loop: true,
        autoplay: true,
        autoplayTimeout: 6000,
        nav: true,
        dots: false,
        navText: [
            "<span class='icon-arrow-left'></span>",
            "<span class='icon-arrow-right'></span>",
        ],
        responsive: {
            0: { items: 2, margin: 50 },
            360: { items: 3, margin: 40 },
            575: { items: 4, margin: 40 },
            768: { items: 4, margin: 80 },
            992: { items: 5, margin: 100 },
            1200: { items: 6, margin: 134 },
        },
    };

    const brandImages = [
        { img: "brand-1-1.png", hoverImg: "brand-1-7.png" },
        { img: "brand-1-2.png", hoverImg: "brand-1-8.png" },
        { img: "brand-1-3.png", hoverImg: "brand-1-9.png" },
        { img: "brand-1-4.png", hoverImg: "brand-1-10.png" },
        { img: "brand-1-5.png", hoverImg: "brand-1-11.png" },
        { img: "brand-1-6.png", hoverImg: "brand-1-12.png" },
    ];

    return (
        <div className={`client-carousel ${extraClassName}`}>
            <div className="container">
                <OwlCarousel
                    className="client-carousel__one cleenhearts-owl__carousel cleenhearts-owl__carousel--basic-nav owl-theme"
                    {...owlOptions}
                >
                    {brandImages.map((brand, index) => (
                        <div key={index} className="client-carousel__item">
                            <img
                                src={`assets/images/resources/${brand.img}`}
                                alt="brand"
                                className="client-carousel__item__img"
                            />
                            <img
                                src={`assets/images/resources/${brand.hoverImg}`}
                                alt="brand"
                                className="client-carousel__item__hover-img"
                            />
                        </div>
                    ))}
                </OwlCarousel>
            </div>
        </div>
    );
};

export default ClientCarousel;
